<template><div><h1 id="medienartikel" tabindex="-1"><a class="header-anchor" href="#medienartikel"><span>Medienartikel</span></a></h1>
<p>Medienartikel — Zuordnung von Artikeln zu einem Medium</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dieses Programm dient der Zuordnung von einzelnen Artikeln zu einem Medium. Das System geht davon aus, dass Artikel immer im Zusammenhang mit einer bestimmten Verkaufsaktion (und damit einem bestimmten Medium = Katalog) verkauft werden. Um spätere statistische Auswertungen zu ermöglichen, können verschiedene medienspezifische Informationen erfasst und ggf. ausgewertet werden. Jeder Artikel kann mit beliebig vielen Medien verkauft werden.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Artikel (Kurzform):</dt>
<dd>Standardinformation zum Artikel</dd>
<dt>Med:</dt>
<dd>Mediumcode</dd>
<dt>Bezeichnung:</dt>
<dd>Bezeichnung des Mediums aus der Tabelle Medien</dd>
<dt>Seite:</dt>
<dd>Seitennummer, auf welcher der Artikel abgebildet ist</dd>
<dt>AbbCd:</dt>
<dd>Abbildungscode</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblmedium.html" title="Medium">Medium</RouteLink></p>
</div></template>


